import React, { useEffect, useState } from 'react'
import './style.scss'
import axios from 'axios'
import Icon from 'react-icons-kit'
import { api } from '../../utils/api'
import { NavLink, useNavigate } from 'react-router-dom'
// import { list, } from 'react-icons-kit/feather'
import {
    ic_dashboard,
    ic_people,
    ic_account_box,
    ic_language,
    ic_keyboard_arrow_right,
    // ic_description,
    // ic_domain,
    // ic_payment,
    // ic_loyalty,
    // ic_bug_report,
    // ic_library_add,
    ic_person_add,
    // ic_no_encryption,
    // ic_work,
    // ic_pregnant_woman,
    // ic_assignment
} from 'react-icons-kit/md'
import { userTie } from 'react-icons-kit/icomoon'
import { standby } from 'react-icons-kit/iconic'
import Navbar from '../navbar/Index'
import { checkUserRole } from '../../utils/Authenticate'
import Layout2 from './Index2'

const Layout = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const [isMenu, setMenu] = useState(false)
    const [loggingOut, setLoggingOut] = useState(false)
    const [notifications] = useState([])
    const [messages] = useState([])
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
    })
    const [userRole, setUserRole] = useState(null)

    useEffect(() => {
        setUserRole(checkUserRole())
    }, [])

    // Toggle menu
    const toggleMenu = event => {
        let current = event.target.getAttribute("data-value")

        if (isMenu === current) {
            setMenu(false)
        } else {
            setMenu(current)
        }
    }

    // Logout
    const doLogout = async () => {
        try {
            setLoggingOut(true)
            const response = await axios.get(`${api}admin/auth/logout`, header)
            if (response.status === 200) {
                localStorage.clear()
                setTimeout(() => {
                    navigate('/')
                }, 2000)
            }
        } catch (error) {
            if (error) {
                localStorage.clear()
                setTimeout(() => {
                    navigate('/')
                }, 2000)
            }
        }
    }
    if (!userRole) return 'loading'

    if (userRole === 'manager') return <Layout2 />
    return (
        <div className="layout">
            {/* Navbar */}
            <div className="navbar-container shadow-sm">
                {notifications && messages ? <Navbar notifications={notifications} messages={messages} toggle={() => setShow(!show)} /> : null}
            </div>

            {/* Sidebar */}
            <div className={show ? "backdrop d-lg-none open-backdrop" : "backdrop d-lg-none"} onClick={() => setShow(false)}></div>

            <div className="sidebar-container">
                <div className={show ? "sidebar shadow open-sidebar" : "sidebar shadow"}>
                    <ul>

                        {/* Dashboard */}
                        <li>
                            <NavLink
                                to="/dashboard"
                                end
                                className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                            ><Icon icon={ic_dashboard} size={20} />Dashboard</NavLink>
                        </li>

                        {/* Website Links */}
                        <li>
                            <div className="sidebar-dropdown-container">
                                <button
                                    type="button"
                                    className="btn shadow-none"
                                    onClick={toggleMenu}
                                    data-value="website"
                                >
                                    <Icon icon={ic_language} size={20} />Website
                                    <Icon icon={ic_keyboard_arrow_right} size={25} className={isMenu === 'website' ? "arrow down" : "arrow"} />
                                </button>

                                <div className={isMenu === 'website' ? "sidebar-dropdown-menu" : "sidebar-dropdown-menu menu-hide"}>
                                    <NavLink
                                        to="/dashboard/website/area-profile"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Area Profile</NavLink>
                                    <NavLink
                                        to="/dashboard/website/profiles-by-profession"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Profiles By Profession</NavLink>
                                    <NavLink
                                        to="/dashboard/website/banner"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Banner</NavLink>
                                    <NavLink
                                        to="/dashboard/website/blog"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Blog</NavLink>
                                      
                                    <NavLink
                                        to="/dashboard/website/story"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Success Story</NavLink>
                                     <NavLink
                                        to="/dashboard/website/about-us"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >About Us</NavLink>
                                     <NavLink
                                        to="/dashboard/website/contact-us"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Contact Us</NavLink>
                                    <NavLink
                                        to="/dashboard/website/terms-and-conditions"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Terms and Conditions</NavLink>
                                     <NavLink
                                        to="/dashboard/website/premium"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Premium</NavLink>
                                     <NavLink
                                        to="/dashboard/website/marriage-counselling"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Marriage Counselling</NavLink>
                                    <NavLink
                                        to="/dashboard/website/expert-counselors-profile"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Expert Counselors Profile</NavLink>

                                    <NavLink
                                        to="/dashboard/website/appointment-booking"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Appointment Booking</NavLink>
                                    <NavLink
                                        to="/dashboard/website/verification-service"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Verification Service</NavLink>
                                    <NavLink
                                        to="/dashboard/website/settings-field"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Setting Fields</NavLink>
                                    <NavLink
                                        to="/dashboard/website/settings-field/value"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Setting Fields Value</NavLink>
                                </div>
                            </div>
                        </li>

                        {/* Accounts Links */}
                        <li>
                            <div className="sidebar-dropdown-container">
                                <button
                                    type="button"
                                    className="btn shadow-none"
                                    onClick={toggleMenu}
                                    data-value="accounts"
                                >
                                    <Icon icon={ic_account_box} size={20} />Accounts
                                    <Icon icon={ic_keyboard_arrow_right} size={25} className={isMenu === 'accounts' ? "arrow down" : "arrow"} />
                                </button>

                                <div className={isMenu === 'accounts' ? "sidebar-dropdown-menu" : "sidebar-dropdown-menu menu-hide"}>
                                    <NavLink
                                        to="/dashboard/accounts/account"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Account</NavLink>
                                    <NavLink
                                        to="/dashboard/accounts/sales"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Package Sales</NavLink>
                                    <NavLink
                                        to="/dashboard/accounts/expense?page=1&limit=30"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Expense</NavLink>
                                </div>
                            </div>
                        </li>

                        {/* Users */}
                        <li>
                            <NavLink
                                to={`/dashboard/users?page=1&limit=50`}
                                className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                            ><Icon icon={ic_people} size={20} />Users</NavLink>
                        </li>

                        {/* Report & Complain */}
                        {/* <li>
                            <NavLink
                                to="/dashboard/report-complain"
                                className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                            ><Icon icon={ic_bug_report} size={20} />Report / Complain</NavLink>
                        </li> */}

                        {/* Membership Packages */}
                        <li>
                            <NavLink
                                to="/dashboard/membership-packages"
                                className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                            ><Icon icon={ic_person_add} size={20} />Membership Packages</NavLink>
                        </li>

                        {/* Marketing */}
                        {/* <li>
                            <div className="sidebar-dropdown-container">
                                <button
                                    type="button"
                                    className="btn shadow-none"
                                    onClick={toggleMenu}
                                    data-value="marketing"
                                >
                                    <Icon icon={ic_work} size={20} />Marketing
                                    <Icon icon={ic_keyboard_arrow_right} size={25} className={isMenu === 'marketing' ? "arrow down" : "arrow"} />
                                </button>

                                <div className={isMenu === 'marketing' ? "sidebar-dropdown-menu" : "sidebar-dropdown-menu menu-hide"}>
                                    <NavLink
                                        to={`/dashboard/marketing/sms?page=1&limit=50`}
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >SMS</NavLink>
                                    <NavLink
                                        to={`/dashboard/marketing/email?page=1&limit=50`}
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >E-mail</NavLink>
                                    <NavLink
                                        to="/dashboard/marketing/push-notification"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Push Notification</NavLink>
                                    <NavLink
                                        to="/dashboard/marketing/web-ad"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Web Ad</NavLink>
                                    <NavLink
                                        to="/dashboard/marketing/birthday-wish"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Birthday Wish</NavLink>
                                </div>
                            </div>
                        </li> */}

                        {/* HRM */}
                        <li>
                            <div className="sidebar-dropdown-container">
                                <button
                                    type="button"
                                    className="btn shadow-none"
                                    onClick={toggleMenu}
                                    data-value="hrm"
                                >
                                    <Icon icon={userTie} size={20} />HRM
                                    <Icon icon={ic_keyboard_arrow_right} size={25} className={isMenu === 'hrm' ? "arrow down" : "arrow"} />
                                </button>

                                <div className={isMenu === 'hrm' ? "sidebar-dropdown-menu" : "sidebar-dropdown-menu menu-hide"}>
                                    <NavLink
                                        to="/dashboard/hrm/dashboard"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Dashboard</NavLink>
                                    <NavLink
                                        to="/dashboard/hrm/user"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >User</NavLink>
                                    <NavLink
                                        to="/dashboard/hrm/employee"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Employee</NavLink>
                                </div>
                            </div>
                        </li>

                        {/* Premium */}
                        {/* <li>
                            <NavLink
                                to="/dashboard/premium"
                                className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                            ><Icon icon={list} size={20} />Premium</NavLink>
                        </li> */}

                        {/* Agents */}
                        {/* <li>
                            <div className="sidebar-dropdown-container">
                                <button
                                    type="button"
                                    className="btn shadow-none"
                                    onClick={toggleMenu}
                                    data-value="ghotok"
                                >
                                    <Icon icon={ic_pregnant_woman} size={20} />Agents
                                    <Icon icon={ic_keyboard_arrow_right} size={25} className={isMenu === 'ghotok' ? "arrow down" : "arrow"} />
                                </button>
                                <div className={isMenu === 'ghotok' ? "sidebar-dropdown-menu" : "sidebar-dropdown-menu menu-hide"}>
                                    <NavLink
                                        to='/dashboard/agents/approved'
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Approved Agents</NavLink>
                                    <NavLink
                                        to="/dashboard/agents/pending"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Pending Agents</NavLink>
                                    <NavLink
                                        to="/dashboard/agents/reject"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Reject Agents</NavLink>
                                    <NavLink
                                        to="/dashboard/agents/sells"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Package Sells</NavLink>
                                    <NavLink
                                        to="/dashboard/agents/comission"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Comission</NavLink>
                                    <NavLink
                                        to="/dashboard/agents/withdraw"
                                        className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                                    >Withdrow Requests</NavLink>
                                </div>
                            </div>
                        </li> */}

                        {/* Notice Board */}
                        {/* <li>
                            <NavLink
                                to="/dashboard/notice-board"
                                className={({ isActive }) => isActive ? "btn shadow-none isActive" : "btn shadow-none"}
                            ><Icon icon={ic_assignment} size={20} />Notice Board</NavLink>
                        </li> */}

                        {/* Logout */}
                        <li>
                            <button
                                type="button"
                                className="btn shadow-none"
                                onClick={doLogout}
                                disabled={loggingOut}
                            >
                                <Icon icon={standby} size={15} />
                                {loggingOut ? <span>Logging out...</span> : <span>Logout</span>}
                            </button>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Layout;
